<template>
  <div>
    <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
      <div>
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item has-feedback label="Tên" prop="name">
            <a-select
              :defaultValue="null"
              placeholder="- Chọn -"
              :loading="loading"
              v-model="form.name"
                option-filter-prop="children"
          :filter-option="filterOption"
          show-search
              allowClear
            >
               <a-select-option
            v-for="item in permissionPossession"
            :key="item"
            :value="item"
            
          >
            {{ item }}
          </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="Mô tả">
            <a-textarea
              v-model="form.description"
              placeholder="Nhập mô tả...."
              :auto-size="{ minRows: 3 }"
            />
          </a-form-model-item>
        </a-form-model>
        <a-divider orientation="left">
          THÔNG TIN CẬP NHẬT
        </a-divider>
        <a-descriptions :column="1">
          <a-descriptions-item label="Tạo bởi">
            {{ form.author && (form.author.fullname || form.author.username) }}
          </a-descriptions-item>
          <a-descriptions-item label="Ngày tạo">
            {{ form.createdAt | formatDateHour }}
          </a-descriptions-item>
          <a-descriptions-item label="Cập nhật lần cuối">
            {{ form.updatedAt | formatDateHour }}
          </a-descriptions-item>
        </a-descriptions>

        <div
          style="text-align: right;"
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-popconfirm
            title="Xác nhận muốn xóa chức vụ."
            ok-text="Có"
            cancel-text="Không"
            @confirm="deleteItem"
          >
            <a-button
              style="margin-right: 5px; float: left;"
              icon="delete"
              :loading="loadingDelete"
              type="danger"
            >
              Xóa
            </a-button>
          </a-popconfirm>

          <a-button @click="closeDrawerUpdate" style="margin-right: 5px;" icon="close">
            Đóng
          </a-button>
          <a-button type="primary" @click="updateItem" :loading="loadingUpdate" icon="edit">
            Cập nhật
          </a-button>
        </div>
      </div>
    </a-skeleton>
  </div>
</template>
<script>
import queryItem from "../data/queryItem";
export default {
  props: {
    updateOnView: {
      type: Function,
      default: null,
    },
    deleteOnView: {
      type: Function,
      default: null,
    },
    closeDrawerUpdate: {
      type: Function,
      default: null,
    },
    itemId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      checkItem: true,
      loading: true,
      loadingUpdate: false,
      loadingDelete: false,
      permissionPossession: [],
      form: {
        name: undefined,
        description: undefined,
      },
      rules: {
      },
    };
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
   getNamePermissionPossessions() {
      this.loading = true;
      this.$apollo
        .query({
          fetchPolicy: "no-cache",
          query: queryItem.getListNamePermissionPossession,
        })
        .then(({ data }) => {
          if (data.getListNamePermissionPossession) {
            this.permissionPossession = [...data.getListNamePermissionPossession];
         
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách vai", error);
          this.loading = false;
        });
    },
    getItem() {
      this.loading = true;
      this.$apollo
        .query({
          fetchPolicy: "no-cache",
          query: queryItem.queryGet,
          variables: {
            id: this.itemId,
          },
        })
        .then(({ data }) => {
          this.getNamePermissionPossessions();
          if (data?.getPermissionPossession) {
            this.form = { ...data.getPermissionPossession };
         

            this.loading = false;
          }
        })
        .catch((error) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Không lấy được chi tiết",
          });
        });
    },
    updateItem() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingUpdate = true;
          this.$apollo
            .mutate({
              mutation: queryItem.queryUpdate,
              variables: {
                ...this.form,
                id: this.itemId,
              },
            })
            .then(({ data }) => {
              if (data?.updatePermissionPossession) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Cập nhật thành công",
                });

                this.closeDrawerUpdate();
                this.updateOnView(data?.updatePermissionPossession);
              }
              this.loadingUpdate = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description: "Cập nhật không thành công, Tên bạn chọn bị trùng",
              });
              this.loadingUpdate = false;
            });
        }
      });
    },
    deleteItem() {
      this.loadingDelete = true;
      this.$apollo
        .mutate({
          mutation: queryItem.queryDelete,
          variables: {
            id: this.itemId,
          },
        })
        .then(({ data }) => {
          if (data?.deletePermissionPossession) {
            this.$notification.success({
              message: "Thông báo",
              description: "Xóa thành công",
            });

            this.closeDrawerUpdate();
            this.deleteOnView(data.deletePermissionPossession);
          }
          this.loadingDelete = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Xóa chức vụ không thành công" + error,
          });
          console.log("Xóa chức vụ không thành công", error);
          this.loadingDelete = false;
        });
    },
  },

  created() {
    this.getItem();
  },
};
</script>
<style></style>
